// Copyright (c) 2017 Deere & Company

import OpenPipFacetState from '../../state/facets';
import OpenPipsAside from './open-pips-aside';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';
import reports from '../../../../routes/pips/reports';

const getStateToBindToContainerProps = state => ({
    facets: new OpenPipFacetState({
        ...state.pips.openPips.facets,
        dealerAccountsFacet: {
            ...state.pips.openPips.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    laborAdditivePipProductsFacets: {
        ...state.pips.laborAdditive.facets,
        dealerAccountsFacet: {
            ...state.pips.openPips.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    },
    openPipsSummary: state.pips.openPips.openPipsSummary,
    reportsAccordion: state.pips.openPips.reportsAccordion,
    reportsRoutes: reports,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OpenPipsAside);



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-aside/index.js